// This file is the API client setup - it's allowed to import from @surface/api-client directly
import { setActiveTenantIdProvider, setBaseUrl } from '@surface/api-client';

import { resolveActiveTenantId } from '../router/tenant-routing';
import { API_ROOT } from '../constants';

setBaseUrl(API_ROOT);

// Register a function (not a snapshot) so every request reads the current
// `/~/:tenantSlug` slug from `window.location.pathname` at call time, resolves
// it to the canonical tenant id, and lets `customFetch` attach the
// `saas-tenant-id` header automatically. On authenticated globals such as
// `/whats-new` there is no URL slug, so this falls back to the session tenant.
setActiveTenantIdProvider(() => resolveActiveTenantId());

export * from '@surface/api-client';
